import { mediciFetch, getApiUrl } from './../../components/utils/NetworkUtils';

export function getIncentiveDetails(uid) {
  return mediciFetch(`${getApiUrl()}/admins/incentive/${uid}`, { method: 'get' });
}

export function getIncentiveReport(uid) {
  return mediciFetch(`${getApiUrl()}/admins/incentive/${uid}/report`, { method: 'get' });
}
